"use client";
import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import cx from "classnames";
import { useEffect, useRef } from "react";
import { Transition } from "react-transition-group";

const Snackbar = (props) => {
  const { className, duration = 3000 } = props;

  const { snackbar, setSnackbar } = useSnackbarContext();

  const nodeRef = useRef();

  const defaultStyle = {
    transform: "translateY(0%)", // Start from above the top edge
    transition: `transform 150ms ease-in-out`,
  };

  const transitionStyles = {
    entering: { transform: "translateY(0%)" },
    entered: { transform: "translateY(0)" },
    exiting: { transform: "translateY(-100%)" },
    exited: { transform: "translateY(-100%)" },
  };

  useEffect(() => {
    if (snackbar?.open) {
      const timer = setTimeout(() => {
        setSnackbar((prev) => ({ ...prev, open: false }));
      }, duration);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [snackbar.open, setSnackbar, duration]);

  return (
    <Transition nodeRef={nodeRef} in={snackbar?.open} timeout={150}>
      {(state) => (
        <div
          ref={nodeRef}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
          className={cx(
            "z-80 fixed left-0 right-0 top-0 p-3 text-center text-white",
            snackbar?.type === "error" && "bg-red-700",
            snackbar?.type === "success" && "bg-icon-color",
            snackbar?.type === "info" && "bg-gray-700",
            className
          )}
        >
          <p>{snackbar?.message}</p>
        </div>
      )}
    </Transition>
  );
};

export default Snackbar;
